// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"353":"2517a08d259d8744","387":"5dc7933ff9a70bf0","837":"7f6cdf9c52c2b330"}[chunkId] + ".js";
};